import { render, staticRenderFns } from "./sitemanage.vue?vue&type=template&id=d210af86&scoped=true&"
import script from "./sitemanage.vue?vue&type=script&lang=js&"
export * from "./sitemanage.vue?vue&type=script&lang=js&"
import style0 from "./sitemanage.vue?vue&type=style&index=0&id=d210af86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d210af86",
  null
  
)

export default component.exports